const riot = require('riot');

riot.tag2('page-companies-single', '<div class="s-full f"> <div class="flex-auto f fclm w0 h-full"> <div class="flex-fixed bg-white elevation-default-mid" data-is="module-page-header" title="会社設定" back="{breadcrumbs[0].link}" breadcrumbs="{breadcrumbs}"></div> <div class="f fclm flex-auto w-full py36 px40 bg-pale_gray"> <form class="flex-fixed bg-white rounded-8 elevation-default-low mb32" onsubmit="{onUpdateCompany}"> <div class="section-padding"> <label class="block w-full"> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">会社名</div> <div class="ts-hxxs text-pink_70">必須</div> </div> <input class="input w-full" ref="name" type="text" placeholder="会社名" required riot-value="{company.name}" oninput="{changeData}"> </label> </div> <div data-is="module-section-footer" buttons="{buttons}"></div> </form> <div class="f fclm w-full flex-height-auto pb32 rounded-8 bg-white elevation-default-mid"> <form class="flex-fixed pt32 px32 mb24" onsubmit="{onInviteUser}"> <div class="mb36" data-is="module-section-header" title="メンバーの管理"> </div> <div class="f fm"> <label class="w-full block mr16"> <input class="input w-full" ref="email" required placeholder="例) help@repro.io" type="email"> </label> <div class="flex-fixed w200 mr16" data-is="atom-input-select" ref="role" options="{app.data.constants.company_roles}" riot-value="{app.data.constants.company_roles[0].id}"></div> <button class="button size-m flex-fixed">メンバーを招待</button> </div> </form> <div class="max-height-500 w-full" data-is="module-table" schemas="{tableSchemas}" items="{companyUsers}"></div> <div class="flex-fixed f fr px28"> <div ref="pagination" data-is="atom-pagination" pagination="{pagination}"></div> </div> </div> </div> </div> </div>', 'page-companies-single,[data-is="page-companies-single"]{display:block}', '', function(opts) {
    this.buttons = [
      {
        type: 'submit',
        text: '保存',
        class: 'outline',
      },
    ];

    this.tableSchemas = [
      {
        id: 'user.name',
        label: 'アカウント名',
        class: 'w284 flex-fixed',
      },
      {
        id: 'user.email',
        label: 'メールアドレス',
        class: 'w284 flex-fixed',
      },
      {
        id: 'role',
        label: '権限',
        class: 'min-width-284 w0 flex-auto',
        getText: (v) => app.utils.getCompanyRoleLabel(v),
      },
      {
        id: 'user',
        component: 'material-icon-button',
        align: 'center',
        class: 'flex-fixed w48',
        text: 'more_vert',
        shouldShow: (item, e) => {
          return item.user.id !== app.utils.auth.currentUser.id;
        },
        onclick: (item, e) => {
          this.onOpenActionSheet(item, e);
        },
      },
    ];
    this.limit = 50;

    this.preload = async ({req, res}) => {
      if (spat.isNode) return;

      var params = {
        limit: this.limit,
        offset: 0,
      };

      var company_id = req.params.company_id;

      var promises = [
        app.api.child(`companies/${company_id}/users`).get(params),
        app.api.child(`companies/${company_id}`).get({}),
      ];

      var [{company_users, pagination}, {company}] = await Promise.all(promises);
      var breadcrumbs = [
        {
          link: `/app/companies/${company.id}/projects`,
          label: 'ダッシュボード',
        },
      ];

      return {
        companyUsers: company_users,
        pagination,
        company,
        breadcrumbs,
      };
    };

    this.on('mount', () => {
      this.refs.pagination.on('paginationchange', async (offset_type) => {
        var indicator = spat.modal.indicator();
        var offset = this.pagination[offset_type];
        try {
          var {company_users, pagination} = await app.api.child(`companies/${this.company.id}/users`).get({ limit: this.limit, offset });
          this.companyUsers = company_users;
          this.pagination = pagination;
          this.update();
        }
        catch (e) {
          console.error(e);
          spat.modal.alert(e.message);
        }
        finally {
          indicator.close();
        }
      })
    });

    this.head = () => {
      return {
        title: app.utils.head.title('会社設定', this),
      };
    };

    this.on('show', () => {
      this.isChange = false;
    });

    this.on('beforeunload', (e) => {
      if (this.isChange) {
        e.returnValue = app.data.beforeunload_text;
      }
    });

    this.on('hide', () => {
      this.reset();
    });

    this.reset = () => {
      this.company = {};
      this.update();
    };

    this.onUpdateCompany = async (e) => {
      e.preventDefault();
      var indicator = spat.modal.indicator();
      try {
        var query = {
          name: this.refs.name.value,
        };

        var {company} = await app.api.child(`companies/${this.company.id}`).put(query);
        this.company = company;
        this.isChange = false;
        this.update();
        spat.modal.alert('更新しました');
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.onInviteUser = async (e) => {
      e.preventDefault();
      var indicator = spat.modal.indicator();
      try {
        var email = this.refs.email.value;
        var role =  this.refs.role.getValue();

        var query = {
          email,
          role,
        };

        var promises = [

          app.api.child(`companies/${this.company.id}/users`).post(query),
        ];
        await Promise.all(promises);

        var { company_users, pagination } = await app.api.child(`companies/${this.company.id}/users`).get({ limit: this.limit, offset:0 });
        this.companyUsers = company_users;
        this.pagination = pagination;
        this.refs.email.value = '';
        this.update();
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.onDeleteUser = async (item) => {
      var modal = await spat.modal.open('modal-confirm', {
        text: '削除しますか？',
      });
      var result = await modal.waitClose();
      if (!result) return;

      var indicator = spat.modal.indicator();
      try {
        await app.api.child(`companies/${this.company.id}/users/${item.user.id}`).del({});

        var { company_users, pagination } = await app.api.child(`companies/${this.company.id}/users`).get({ limit: this.limit, offset:0 });
        this.companyUsers = company_users;
        this.pagination = pagination;
        this.update();
        spat.modal.alert('削除しました');
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.onOpenActionSheet = (item, e) => {
      e.preventDefault();
      e.stopPropagation();
      var options = [
        {
          icon: "pencil",
          label: "権限の変更",
          action: () => { popup.close(); this.openRoleChangeModal(item); },
        },
        {
          icon: "trash",
          label: "削除",
          action: () => { popup.close(); this.onDeleteUser(item); },
          alert: true,
        },
      ];

      var popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 8,
        align: {x: 'right'},
        position: 'bottom',
        opts: {
          options,
        },
      });
    };

    this.openRoleChangeModal = async (item) => {
      var buttons = [
        {
          type: 'button',
          text: 'キャンセル',
          class: 'text',
          onclick: () => modal.close(),
        },
        {
          type: 'submit',
          text: '変更',
          class: 'outline',
        },
      ];
      var query = {
        title: 'ロールを変更しますか？',
        items: app.data.constants.company_roles,
        current: item,
        buttons,
        submit: (v) => this.putUserRole(v, item),
      };

      var modal = await spat.modal.open('modal-select-radio', query);
    };

    this.changeData = () => {
      this.isChange = true;
    };

    this.putUserRole = async (value, item) => {
      var indicator = spat.modal.indicator();
      try {
        await app.api.child(`companies/${this.company.id}/users/${item.user.id}`).put({ role: value });
        var { company_users, pagination } = await app.api.child(`companies/${this.company.id}/users`).get({ limit: this.limit, offset:0 });
        this.companyUsers = company_users;
        this.pagination = pagination;
        this.update();
        spat.modal.alert('更新しました');
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };
});